import * as Yup from "yup";
import { type AccountTypeEnum } from "../../graphql/supergraphTypes";
import { Question } from "../EntityTypeSurvey/types";
import { AddressFormValues } from "../IndividualForm/types";
import { createEntityProfileSchema } from "./schemas";

export type EntityProfile = Yup.InferType<ReturnType<typeof createEntityProfileSchema>>;

export const defaultInitialValues = {
  legalBusinessName: "",
  entityType: null,
  dateOfFormation: null,
  identificationNumber: "",
  streetLine1: "",
  streetLine2: "",
  city: "",
  state: "",
  province: "",
  zip: "",
  country: "",
  updatedQuestions: [],
};

export interface EntityProfileFormValues extends AddressFormValues {
  legalBusinessName: string;
  entityType: AccountTypeEnum | null;
  dateOfFormation: Date | null;
  identificationNumber: string;
  updatedQuestions?: Question[];
}

export interface EntityFormProps {
  isUpdating: boolean;
  onSubmit: (entityProfile: EntityProfile) => Promise<void>;
  onBack: () => void;
  initialValues: EntityProfileFormValues;
  title?: string;
  description?: string;
  profileId?: number;
  amlEntityTypeId?: number | null;
  onDefaultQuestionsChange?: (defaultQuestions: number[]) => void;
  isController?: boolean;
}
